import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import AppRoutes, { AppRouteViews } from './AppRoutes';
import './App.css';

const themeStorageKey = 'prapti-theme';
type Theme = 'light' | 'dark';

function getInitialTheme(): Theme {
  if (typeof window === 'undefined') {
    return 'light';
  }

  const storedTheme = window.localStorage.getItem(themeStorageKey);
  if (storedTheme === 'light' || storedTheme === 'dark') {
    return storedTheme;
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function App() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    window.localStorage.setItem(themeStorageKey, theme);
  }, [theme]);

  const isDark = theme === 'dark';

  return (
    <AppRoutes>
      <div className="site-shell" data-theme={theme}>
        <header className="site-header">
          <NavLink className="brand" to="/">
            Prapti
          </NavLink>
          <div className="site-header-actions">
            <nav aria-label="Main navigation" className="site-nav">
              <NavLink to="/">Home</NavLink>
              <NavLink to="/blog">Posts</NavLink>
              <NavLink to="/projects">Work</NavLink>
              <NavLink to="/resume">CV</NavLink>
              <NavLink to="/wc26">WC 26</NavLink>
              <NavLink to="/privacy">Privacy</NavLink>
            </nav>
            <button
              type="button"
              className="theme-toggle"
              role="switch"
              aria-checked={isDark}
              aria-label="Toggle dark mode"
              onClick={() => setTheme(isDark ? 'light' : 'dark')}
            >
              <span className="theme-toggle-track" aria-hidden="true">
                <span className="theme-toggle-thumb" />
              </span>
              <span className="theme-toggle-label">{isDark ? 'Dark' : 'Light'}</span>
            </button>
          </div>
        </header>
        <main>
          <AppRouteViews />
        </main>
      </div>
    </AppRoutes>
  );
}

export default App;
